import { render, staticRenderFns } from "./pointSetting_2.vue?vue&type=template&id=ada97b0c&scoped=true"
import script from "./pointSetting_2.vue?vue&type=script&lang=js"
export * from "./pointSetting_2.vue?vue&type=script&lang=js"
import style0 from "./pointSetting_2.vue?vue&type=style&index=0&id=ada97b0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada97b0c",
  null
  
)

export default component.exports